import { buildCompactStatementRow } from './sharedRowFields';

const adaptPayableStatement = (statement, transaction) => {
    return buildCompactStatementRow({
        statement,
        transaction,
        extra: {
            TransactionFamily: statement.TransactionFamily ?? transaction?.Family,
        },
    });
};

export const adaptPayableRow = (row) => {
    if (!row) {
        return row;
    }

    if (row.isPayment) {
        return {
            ...row,
            key: row.ID,
            sourceType: 'payable-payment',
            LineRole: 'payment',
        };
    }

    const statements = (row.Statements || []).map((statement) => adaptPayableStatement(statement, row));

    return {
        ...row,
        key: row.ID,
        Statements: statements,
        mainStatement: statements.find((statement) => !statement.isCommission && !statement.isClientAdvance) || null,
        commissionStatement: statements.find((statement) => statement.isCommission) || null,
        clientAdvanceStatement: statements.find((statement) => statement.isClientAdvance) || null,
        sourceType: 'payable-transaction',
        LineRole: 'transaction',
    };
};

export const adaptPayableRows = (rows = []) => {
    return rows.map(adaptPayableRow);
};
